import Branch from 'branch-sdk'

export const branchLogOut = () => {
  Branch.logout()
}

export const branchSetIdentity = (userAlias) => {
  Branch.setIdentity(userAlias)
}
